import { SxProps, Theme } from '@mui/material';

/** Same Day Delivery tag ("Same Day Tag Migración 2025"). */
export const tagSx: SxProps<Theme> = (theme: Theme) => ({
	display: 'inline-flex',
	alignItems: 'center',
	// Item spacing between the bolt icon and the label.
	gap: '5px',
	alignSelf: 'flex-start',
	padding: '5px',
	borderRadius: '3px',
	backgroundColor: theme.palette.goldHighlight.main,
	color: theme.palette.goldHighlight.dark,
	whiteSpace: 'nowrap',
});
